import { useTranslation } from 'react-i18next';
import { GeneratedWinners } from '@/components/GeneratedWinners';
import { NewWinner } from '../../NewWinner';

import { ScNewWinners } from '../../styled';

interface IWinnersProps {
  itemsPerView?: number;
  title?: string;
  onClick?: () => void;
}

export const Winners = ({ itemsPerView, title, onClick }: IWinnersProps) => {
  const { t } = useTranslation('common');
  return (
    <div className="winner-box new-winners">
      <h3 className="subtitle">
        {title ? title : t('starWinners.newWinners')}
      </h3>
      <ScNewWinners>
        <GeneratedWinners
          itemsPerView={itemsPerView}
          onClick={onClick}
          winnerItem={NewWinner}
        />
      </ScNewWinners>
    </div>
  );
};
